#import "./drip-progression-editions-fragment.graphql"

fragment DripProgressionFragment on DripProgression {
    id
    nextEditionSendTime
    numEditionsSent
    campaign {
        id
        name
        status
        htmlUrlPath
        isStopOnLeadClose
        startTrigger {
            id
            humanReadableTitle
            humanReadableSubtitle
        }
        goal {
            id
            humanReadableTitle
            humanReadableSubtitle
        }
        from {
            id
            creatorUser {
                id
                name
            }
        }
    }
    editions {
        ...DripProgressionEditionsFragment
    }
}
